import {useMemo} from "react";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import {AmenitiesType} from "@CheckOrder/features/amenities/types/Amenities.type";
import appendAmenityKeysList from "@CheckOrder/features/amenities/functions/appendAmenityKeysList";

/*
 * creates object where amenity groups for return and single direction are grouped by their groupID.
 * Returns singleAmenityGroup, returnAmenityGroup and all their amenityKeys
 */
export default function usePairSingleAndReturnAmenityGroups(amenities: AmenitiesType) {
    const {
        returnRouteAmenities,
        singleRouteAmenities,
    } = amenities || {}

    const pairedSingleAndReturnAmenities: Record<string, PairedSingleAndReturnAmenitiesType> = useMemo(() => {
        // add all single Route Amenities to the group
        let pairedAmenities: Record<string, PairedSingleAndReturnAmenitiesType> = singleRouteAmenities.reduce((acc, singleGroup) => {
            acc[singleGroup.id] = {
                singleGroup,
                returnGroup: null,
                amenityKeys: appendAmenityKeysList(singleGroup, []),
            }
            return acc
        }, {})

        // add all return Route Amenities to the group
        pairedAmenities = returnRouteAmenities.reduce((acc, returnGroup) => {
            if (!acc[returnGroup.id]) {
                acc[returnGroup.id] = {
                    singleGroup: null,
                    returnGroup,
                    amenityKeys: appendAmenityKeysList(returnGroup, []),
                }
                return acc
            }
            acc[returnGroup.id] = {
                singleGroup: acc[returnGroup.id].singleGroup,
                returnGroup,
                amenityKeys: appendAmenityKeysList(returnGroup, acc[returnGroup.id].amenityKeys),
            }
            return acc
        }, pairedAmenities)

        return pairedAmenities
    }, [])

    return {
        pairedSingleAndReturnAmenities,
    }
}